module.exports = __webpack_public_path__ + "img/aawaz-logo-white.6879c1e2.png";